import ChatbotWidget from './ChatbotWidget';

export default ChatbotWidget;